/**
 * Tema do dashboard (US-4328).
 * Preferência: 'light' | 'dark' | 'auto' ('auto' segue o SO).
 * O helper resolve a preferência e escreve data-theme="dark|light" no <html>.
 * A preferência é cacheada em localStorage para o script anti-flash do layout
 * aplicar o tema antes do Vue subir; a fonte de verdade por usuário é
 * ui_settings.color_scheme.
 */
export const THEME_STORAGE_KEY = 'omnidesk_color_scheme';
export const THEME_OPTIONS = ['light', 'dark', 'auto'];
const DARK_MEDIA = '(prefers-color-scheme: dark)';

export const getStoredThemePreference = () => {
  try {
    const value = window.localStorage.getItem(THEME_STORAGE_KEY);
    return THEME_OPTIONS.includes(value) ? value : 'auto';
  } catch (e) {
    return 'auto';
  }
};

export const setStoredThemePreference = preference => {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, preference);
  } catch (e) {
    // localStorage indisponível (aba privada etc.) — ignora
  }
};

export const prefersSystemDark = () => {
  return (
    typeof window.matchMedia === 'function' &&
    window.matchMedia(DARK_MEDIA).matches
  );
};

export const resolveIsDark = preference => {
  const pref = THEME_OPTIONS.includes(preference) ? preference : 'auto';
  if (pref === 'dark') return true;
  if (pref === 'light') return false;
  return prefersSystemDark();
};

/**
 * Aplica o tema resolvido no <html> e cacheia a preferência.
 * Retorna true se o tema resultante for escuro.
 */
export const applyThemePreference = preference => {
  const isDark = resolveIsDark(preference);
  document.documentElement.setAttribute(
    'data-theme',
    isDark ? 'dark' : 'light'
  );
  setStoredThemePreference(preference);
  return isDark;
};

/**
 * Observa mudanças do tema do SO enquanto a preferência é 'auto'.
 * Retorna uma função para remover o listener.
 */
export const watchSystemTheme = onChange => {
  if (typeof window.matchMedia !== 'function') return () => {};
  const mql = window.matchMedia(DARK_MEDIA);
  const handler = () => onChange();
  if (mql.addEventListener) {
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }
  // fallback navegadores antigos
  mql.addListener(handler);
  return () => mql.removeListener(handler);
};
